import moment from "moment";
export function parseDate(d) {
    return moment(d).local().toDate();
}
export function formatDateHuman(d) {
    return moment(d).format('DD/MM/YYYY');
}
export function formatTimestampHuman(d) {
    return moment(d).format('DD/MM/YYYY HH:mm');
}
export function parseDateRaw(d) {
    return moment(d, 'YYYYMMDD').local().toDate();
}
export function parseDateISO(d) {
    return moment(d, 'YYYY-MM-DD').local().toDate();
}
export function formatDateRaw(d) {
    return moment(d).format('YYYYMMDD');
}
export function formatDateOnlyISO(d) {
    return moment(d).format('YYYY-MM-DD');
}
export function formatCurrency(val) {
    return '€ ' + (val || 0).toFixed(2);
}
